@if (userStore.user(); as user) {
  <form tbs-form tbsLayout="vertical" [formGroup]="userForm">
    <div class="user-basics">
      <div class="user-profile">
        <div class="user-profile-image">
          @if (profilePicture()) {
            <img alt="profile image" [src]="profilePicture()!" />
          }
        </div>

        <core-file-upload
          [id]="data()?._id"
          [title]="'Upload Image'"
          [noteClass]="'tb-caption'"
          [control]="userForm?.get('profile_picture')"
          [fileTypes]="['image/png', 'image/jpg', 'image/jpeg']"
          (emitFile)="uploadProfilePicture($event)"
        />

        @if (profilePicture() !== undefined && deleteProfileImage()) {
          <button
            class="delete-uploaded-image"
            tbs-button
            tbsType="text"
            tbsIconPosition="left"
            (click)="deleteUploadedImage()"
          >
            <tbs-icon icon="calcite:trash-24" />
            Delete Image
          </button>
        }
      </div>
      <div>
        <div class="form-control">
          <tbs-form-item>
            <tbs-form-label>First Name</tbs-form-label>
            <tbs-form-control [tbsErrorTip]="firstNameErrorTpl">
              <input tbs-input placeholder="Your First Name" type="text" formControlName="first_name" />
              <ng-template #firstNameErrorTpl let-control>
                @if (control.errors?.['required']) {
                  This field is required.
                }
              </ng-template>
            </tbs-form-control>
          </tbs-form-item>
        </div>
        <div class="form-control">
          <tbs-form-item>
            <tbs-form-label>Last Name</tbs-form-label>
            <tbs-form-control [tbsErrorTip]="lastNameErrorTpl">
              <input tbs-input placeholder="Your Last Name" type="text" formControlName="last_name" />
              <ng-template #lastNameErrorTpl let-control>
                @if (control.errors?.['required']) {
                  This field is required.
                }
              </ng-template>
            </tbs-form-control>
          </tbs-form-item>
        </div>
        <div class="form-control">
          <tbs-form-item>
            <tbs-form-label>Email</tbs-form-label>
            <tbs-form-control [tbsErrorTip]="emailErrorTpl">
              <input tbs-input placeholder="Your Email" type="text" formControlName="email" />
              <ng-template #emailErrorTpl let-control>
                @if (control.errors?.['required']) {
                  This field is required.
                }
              </ng-template>
            </tbs-form-control>
          </tbs-form-item>
        </div>
        <div class="form-control">
          <tbs-form-item>
            <tbs-form-label>Title</tbs-form-label>
            <tbs-form-control>
              <input tbs-input placeholder="Please enter title" type="text" formControlName="position" />
            </tbs-form-control>
          </tbs-form-item>
        </div>
      </div>
    </div>
    <div class="form-control description">
      <tbs-form-item>
        <tbs-form-label>Description</tbs-form-label>
        <tbs-form-control>
          <textarea
            tbs-input
            rows="3"
            placeholder="Add a few words about yourself"
            formControlName="description"
          ></textarea>
        </tbs-form-control>
      </tbs-form-item>
    </div>
    <div class="form-control">
      <tbs-form-item>
        <tbs-form-label>Video Introduction</tbs-form-label>
        <tbs-form-control>
          <input tbs-input placeholder="Copy URL here" type="text" formControlName="video_introduction" />
        </tbs-form-control>
      </tbs-form-item>
    </div>

    <div class="form-control">
      <tbs-form-item>
        <tbs-form-label>Geographical focus</tbs-form-label>
        <tbs-form-control>
          <input tbs-input placeholder="Please enter geographical focus" type="text" formControlName="sales_region" />
        </tbs-form-control>
      </tbs-form-item>
    </div>

    <div class="form-control">
      <tbs-form-item>
        <tbs-form-label>Phone number</tbs-form-label>
        <tbs-form-control>
          <input tbs-input formControlName="phone_number" placeholder="Enter phone number" />
        </tbs-form-control>
      </tbs-form-item>
    </div>

    <div class="form-control">
      <tbs-form-item>
        <tbs-form-label>Role</tbs-form-label>
        <tbs-form-control>
          <tbs-select formControlName="roles" [tbsDisabled]="true">
            @for (role of roles(); track role) {
              <tbs-option [tbsValue]="role.value" [tbsLabel]="role.text" />
            }
          </tbs-select>
        </tbs-form-control>
      </tbs-form-item>
    </div>
  </form>
}
